import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mas me-2" }, "pending", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mas me-2" }, "done", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "error", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status === _ctx.autoSaveFeedbackStatusEnum.UNSAVED_CHANGES)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`text-muted d-flex align-items-center ${_ctx.wrapperClass}`)
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.unsavedChangesText), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.status === _ctx.autoSaveFeedbackStatusEnum.BUSY)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`text-info d-flex align-items-center ${_ctx.wrapperClass}`)
        }, [
          _hoisted_1,
          _createElementVNode("span", null, _toDisplayString(_ctx.busyText), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.status === _ctx.autoSaveFeedbackStatusEnum.SUCCESS)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(`text-success d-flex align-items-center ${_ctx.wrapperClass}`)
        }, [
          _hoisted_2,
          _createElementVNode("span", null, _toDisplayString(_ctx.successText), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.status === _ctx.autoSaveFeedbackStatusEnum.FAILED)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(`text-danger d-flex align-items-center ${_ctx.wrapperClass}`)
        }, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.failedText), 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}